module.exports = __webpack_public_path__ + "static/media/customer-database.ada66b9c.png";